import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { map, shareReplay } from 'rxjs/operators'

import { FundDetails, FundFamily } from '../models/fund-details.model'
const FUND_DETAIL_PATH = 'funddetail'
const FUND_FAMILY_PATH = 'fundfamily'
const FUND_FAMILY_DETAIL_PATH = 'fundfamilydetail/'


@Injectable({
  providedIn: 'root',
})
export class FundDetailService {
  private readonly fundDetailObservable: Observable<FundDetails>
  private readonly fundFamilyObservable: Observable<FundFamily>
  private fundFamilyDetailObservable: Observable<FundDetails>
  public static readonly fundDetailPath = FUND_DETAIL_PATH
  constructor(private readonly http: HttpClient,
              public readonly router: Router) {
    let productType = router.url.includes('529-portfolios') ? '/plan529' : '/all'
    this.fundDetailObservable = http
      .get<FundDetails>(FundDetailService.fundDetailPath + productType)
      .pipe(shareReplay());

      this.fundFamilyObservable = http
      .get<FundFamily>(FUND_FAMILY_PATH)
      .pipe(shareReplay())
  }
  public getfunddetail(): Observable<any> {
    return this.fundDetailObservable.pipe(
      map((response) => {
        return response
      }),
    )
  }
  public getfundFamily(): Observable<any> {
    return this.fundFamilyObservable.pipe(
      map((response) => {
        return response
      }),
    )
  }


public getfundFamilyDetail(fundFamilyId: string): Observable<any> {
    this.fundFamilyDetailObservable = this.http
      .get<FundDetails>(FUND_FAMILY_DETAIL_PATH + fundFamilyId)
      .pipe(shareReplay())

    return this.fundFamilyDetailObservable.pipe(
      map((response) => {
        return response
      }),
    )
  }
}
